import { gql } from '@apollo/client'

export default gql`
  fragment ProductReviews on Product {
    productReviews(cursor: $reviewCursor, limit: $reviewLimit) {
      averageRating
      count
      translatedCount
      cursor
      productReviews {
        id
        createdAt
        customerName
        locale
        localizedText
        localizedTitle
        rating
      }
    }
  }
`
